export default __webpack_public_path__ + "static/media/zoom-out-icon.547ab35b.svg";